export var createIndexArray = function (length) {
    return Array.apply(null, Array(length)).map(function (_, i) { return i; });
};
